import { getCompanyDetails } from "@/graphql/functions/getCompanyDetails";

// This function checks if the current authenticated user has on-account payment enabled on their company account.
// @return {Promise<boolean>} - Returns true if on-account payment is enabled, false otherwise. Throws an error if unable to fetch company details.
export async function doesCurrentAuthenticatedUserHaveOnAccountPaymentEnabled(): Promise<boolean> {
    try {
        let companyDetails = null;

        companyDetails = await getCompanyDetails(false);

        const hasOnAccount = companyDetails.hasOnAccountPayment;

        if (hasOnAccount === true) {
            return true;
        }
        return false;
    } catch (error) {
        console.error("Error fetching company details:", error);
        throw error;
    }
}
